import React from "react";
import EditSite from "../../../components/AddAndEditSite/EditSite ";

function EditSitePage() {
  return <EditSite />;
}

export default EditSitePage;
